import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { PATHNAMES } from "src/constants/routes";
import { profileTrns } from "./trns";
import avatarImage from "./temp/default-avatar.svg";
import { Avatar } from "../Avatar";
import { Link } from "../Link";

interface Props {
  avatarUrl: string;
  fullName: string;
}
export const ProfileCard: FC<Props> = ({ avatarUrl, fullName }) => {
  const { t } = useTranslation();

  return (
    <Link
      href={PATHNAMES.CABINET}
      className="flex  justify-center items-center gap-2 !brightness-100"
    >
      <Avatar
        className="text-xs"
        avatarUrl={avatarUrl || avatarImage}
        altText={t(profileTrns.altUserName)}
      />
      <span className="hidden xl:block text-lg">{fullName}</span>
    </Link>
  );
};
